import {
  autoLoginAction,
  resetStateAction,
  getDevicesAction,
  addNotificationAction,
  editUserInfoAction,
  editDeviceInfoAction,
  updateAccountTypeAction,
  coldResetAction,
  factoryResetAction,
  registerDeviceAction,
  setDeviceInfoAction,
  updateFirmwareAction,
  getWeatherAction,
  sendMessageAction,
} from "./actions";

const autoLogin = (dispatch) => (payload) => dispatch(autoLoginAction(payload));
const getDevices = (dispatch) => () => dispatch(getDevicesAction());
const resetState = (dispatch) => () => dispatch(resetStateAction());
const addNotifications = (dispatch) => (payload) =>
  dispatch(addNotificationAction(payload));
const editUserInfo = (dispatch) => (payload) =>
  dispatch(editUserInfoAction(payload));
const editDeviceInfo = (dispatch) => (payload) =>
  dispatch(editDeviceInfoAction(payload));
const updateAccountType = (dispatch) => (payload) =>
  dispatch(updateAccountTypeAction(payload));
const coldReset = (dispatch) => (payload) => dispatch(coldResetAction(payload));
const factoryReset = (dispatch) => (payload) =>
  dispatch(factoryResetAction(payload));
const registerDevice = (dispatch) => (payload) =>
  dispatch(registerDeviceAction(payload));
const setDeviceInfo = (dispatch) => (payload) =>
  dispatch(setDeviceInfoAction(payload));
const updateFirmware = (dispatch) => (payload) =>
  dispatch(updateFirmwareAction(payload));
const getWeather = (dispatch) => (payload) =>
  dispatch(getWeatherAction(payload));
const sendMessage = (dispatch) => (payload) =>
  dispatch(sendMessageAction(payload));

const operations = {
  autoLogin,
  resetState,
  getDevices,
  addNotifications,
  editUserInfo,
  editDeviceInfo,
  updateAccountType,
  coldReset,
  factoryReset,
  registerDevice,
  setDeviceInfo,
  updateFirmware,
  getWeather,
  sendMessage,
};

export default operations;
